import $ from '~/qwery';
import bean from '~/bean';
import Button from '~/components/button';
import RadioGroup from '~/components/radio-group';
import Validation from '~/components/validation';

export default class Form {
    constructor(form) {
        this.$el = $(form);
        const inputSels = ['input[type=text]', 'input[type=password]', 'input[type=email]'];
        $('.b-button', this.$el).each(b => {
            new Button(b);
        });
        $('.b-radio-group', this.$el).each(rg => {
            new RadioGroup(rg);
        });
        this._validation = new Validation(this.$el);
        bean.on(this.$el[0], 'keydown', inputSels.join(','), e => {
            if (e.key == 'Enter')
                bean.fire($('[role=button]', this.$el)[0], 'press');
        });
    }

    validate() {
        return this._validation.validate.apply(this._validation, arguments);
    }

    getData() {
        return this._validation.getData();
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/form.js